import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { equals, pluck } from "ramda";
import { SearchDropdownIcon, SmallCloseIcon } from "../../../../assets/svg";
import { getValueByKey } from "../../../../helper/helpers";
import React from "react";

export const MultipleSelectIcon = ({
  allowClear,
  defaultValue,
  disabled,
  dropdownVisible,
  onChange,
  optionValueProp,
  setState,
  showSearch,
  value,
}) => {
  const selItemsValues = pluck(optionValueProp, value) || [];
  const isValueEqDefault = !equals(
    selItemsValues,
    pluck(optionValueProp, defaultValue)
  );

  const clearHandler = () => {
    onChange(defaultValue);
    setState((st) => ({
      ...st,
      dropdownVisible: false,
    }));
  };

  return (
    <>
      {allowClear &&
      isValueEqDefault && //computationally expensive
      !dropdownVisible ? (
        <button
          className={`clear-btn ${disabled ? "disabled" : ""}`}
          disabled={disabled}
          onClick={clearHandler}
        >
          <SmallCloseIcon />
        </button>
      ) : dropdownVisible ? (
        <UpOutlined style={{ fontSize: "1.1rem" }} />
      ) : (
        <DownOutlined />
      )}
    </>
  );
};

export const SingleSelectIcon = ({
  allowClear,
  defaultValue,
  disabled,
  dropdownVisible,
  onChange,
  optionValueProp,
  setState,
  showSearch,
  value,
}) => {
  const isValueEqDefault =
    value !== getValueByKey(defaultValue, optionValueProp);

  const clearHandler = () => {
    onChange(defaultValue);
    setState((st) => ({
      ...st,
      dropdownVisible: false,
    }));
  };

  return (
    <>
      {allowClear && isValueEqDefault && !dropdownVisible ? (
        <button
          className={`clear-btn ${disabled ? "disabled" : ""}`}
          disabled={disabled}
          onClick={clearHandler}
        >
          <SmallCloseIcon />
        </button>
      ) : showSearch && dropdownVisible ? (
        <SearchDropdownIcon />
      ) : !showSearch && dropdownVisible ? (
        <UpOutlined />
      ) : (
        <DownOutlined />
      )}
    </>
  );
};
